import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../../store'
import { config } from '../../shared/app.config'

store.commit('languages/recoverLanguages')

store.commit('languages/recoverCurrentLanguage')

const languages = store.getters['languages/getLanguages']

const lang = store.getters['languages/getCurrentLanguage']

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      if (locale === lang) {
        messages[locale] = locales(key)
      }
    }
  })
  return messages
}

export default new VueI18n({
  locale: lang,
  locales: languages,
  fallbackLocale: lang,
  messages: loadLocaleMessages(),
})
